import { NavigationMenuLink } from '@/atoms/components/ui/navigation-menu'
import { MenuShell } from './DesktopNav'
import { ArrowRight } from 'lucide-react'
import Link from 'next/link'
import Image from 'next/image'

export const ResourcesMenu = () => {
  return (
    <MenuShell>
      <div className="grid gap-6 lg:grid-cols-[2fr_1fr]">
        <div className="grid gap-4 md:grid-cols-2">
          <NavigationMenuLink asChild>
            <Link
              href="/case-study"
              className="rounded-2xl border border-[#4242B6] pt-4 flex flex-col gap-y-4 bg-[#060135]"
            >
              <div className="flex items-center justify-between px-4">
                <div className="flex flex-col gap-y-1">
                  <p className="text-base font-semibold text-white">
                    Customer Stories
                  </p>
                  <p className="text-sm text-slate-300">
                    Real results from leading brands
                  </p>
                </div>
                <ArrowRight className="h-4 w-4 text-slate-400" />
              </div>
              <div className="relative w-full h-[120px]">
                <Image
                  fill
                  src="/assets/inc/nav/customer-stories.png"
                  alt=""
                  className="object-cover"
                />
              </div>
            </Link>
          </NavigationMenuLink>
          <NavigationMenuLink asChild>
            <Link
              href="/careers"
              className="rounded-2xl border border-[#4242B6] pt-4 flex flex-col gap-y-4 bg-[#060135]"
            >
              <div className="flex items-center justify-between px-4">
                <div className="flex flex-col gap-y-1">
                  <p className="text-base font-semibold text-white">
                    Careers & Culture
                  </p>
                  <p className="text-sm text-slate-300">
                    Build the future of marketing.
                  </p>
                </div>
                <ArrowRight className="h-4 w-4 text-slate-400" />
              </div>
              <div className="relative w-full h-[120px]">
                <Image
                  fill
                  src="/assets/inc/nav/careers-culture.png"
                  alt=""
                  className="object-cover"
                />
              </div>
            </Link>
          </NavigationMenuLink>
          <NavigationMenuLink asChild>
            <Link
              href="/blog"
              className="rounded-2xl border border-[#4242B6] pt-4 flex flex-col gap-y-4 bg-[#060135]"
            >
              <div className="flex items-center justify-between px-4">
                <div className="flex flex-col gap-y-1">
                  <p className="text-base font-semibold text-white">
                    Blogs & Insights
                  </p>
                  <p className="text-sm text-slate-300">
                    Ideas shaping content and creativity.
                  </p>
                </div>

                <ArrowRight className="h-4 w-4 text-slate-400" />
              </div>
              <div className="relative w-full h-[120px]">
                <Image
                  fill
                  src="/assets/inc/nav/blogs-insights.png"
                  alt=""
                  className="object-cover"
                />
              </div>
            </Link>
          </NavigationMenuLink>
          <NavigationMenuLink asChild>
            <Link
              href="/about-us"
              className="rounded-2xl border border-[#4242B6] pt-4 flex flex-col gap-y-4 bg-[#060135]"
            >
              <div className="flex items-center justify-between px-4">
                <div className="flex flex-col gap-y-1">
                  <p className="text-base font-semibold text-white">About Us</p>
                  <p className="text-sm text-slate-300">
                    Who we are and what drives us.
                  </p>
                </div>
                <ArrowRight className="h-4 w-4 text-slate-400" />
              </div>
              <div className="relative w-full h-[120px]">
                <Image
                  fill
                  src="/assets/inc/nav/about-us.png"
                  alt=""
                  className="object-cover"
                />
              </div>
            </Link>
          </NavigationMenuLink>
        </div>

        <NavigationMenuLink asChild>
          <Link
            href="https://index-26.pepper.inc/"
            target="_blank"
            className="rounded-2xl border border-[#4242B6] p-4 flex flex-col gap-y-3 bg-[#060135]"
          >
            <div className="flex items-center justify-between">
              <div className="flex flex-col gap-y-1">
                <p className="text-base font-semibold text-white">Events</p>
                <p className="text-sm text-slate-300">
                  Conversations defining the future of AI, content, and search.
                </p>
              </div>
              <ArrowRight className="h-4 w-4 text-slate-400" />
            </div>
            <div className="relative w-full aspect-16/10 rounded-xl overflow-hidden">
              <Image
                fill
                src="/assets/inc/nav/index26.png"
                alt="Index'26 — The GEO Growth Summit"
                className="object-contain"
              />
            </div>
            <div className="flex flex-col gap-y-1">
              <p className="text-sm font-semibold text-white">
                Index&apos;26 Bengaluru: India&apos;s First GEO Growth Summit
              </p>
              <p className="text-xs text-slate-400">July 2026 · Bengaluru</p>
            </div>
            <span className="text-sm font-medium text-white underline underline-offset-2">
              Know more →
            </span>
          </Link>
        </NavigationMenuLink>
      </div>
    </MenuShell>
  )
}
